import { DateTimeFormatStyle } from "@hopper-b2b/i18n";
import {
  type Branding,
  ClientName,
  I18nNamespace,
  type TranslatableBrandAttributes,
  TranslationLanguage,
  ChatAvailability,
} from "@hopper-b2b/types";
import { CUSTOMER_SUPPORT_PATH } from "@hsbc/utilities";

const defaultConfig: TranslatableBrandAttributes = {
  dateFormat: "DD/MM/YYYY",
  portalName: "HSBC Rewards | Travel with Points",
  preferredCountryCode: "IN",
  preferredAreaCode: "+91",
  urls: {
    helpCenterBaseUrl: CUSTOMER_SUPPORT_PATH,
    termsAndConditions: "https://hts.hopper.com/legal/HSBC-IN",
    privacyPolicy: "https://hts.hopper.com/legal/privacy-policy",
    hsbcTerms:
      "https://www.hsbc.co.in/content/dam/hsbc/in/documents/hsbc-rewards-tcs.pdf",
    cfarTerms: "https://hts.hopper.com/legal/HSBC-IN",
    disruptionTerms: "https://hts.hopper.com/legal/HSBC-IN",
    benefitsFromAirline:
      "https://hts.hopper.com/legal/hts-passenger-rights-overview",
  },
  rewardsPriceFormatterKey: "{{amount}} Points",
  "@rewardsPriceFormatterKey": {
    description:
      "text - A number of points. PH({{amount}}|100|number of points)",
  },
  calendarMonthFormatStyle: DateTimeFormatStyle.Custom({
    month: "long",
    year: "numeric",
  }),
};

export const branding: Branding = {
  clientName: ClientName.HSBC_IN,
  currencies: [
    {
      locale: "en-IN",
      code: "INR",
      symbol: "₹",
      symbolOverride: "₹ ",
    },
  ],
  contactSupport: {
    chatAvailability: ChatAvailability.None,
    displaySupportNumber: "000 80008 20206",
    displayIntlSupportNumber: "+44 20 4623 5225",
    supportNumber: "0008000820206",
    intlSupportNumber: "+442046235225",
  },
  [I18nNamespace.translation]: {
    [TranslationLanguage["en"]]: defaultConfig,
    [TranslationLanguage["en-GB"]]: defaultConfig,
    [TranslationLanguage["en-IN"]]: defaultConfig,
  },
  default: "en-IN",
  supportedLanguages: [
    { key: "en-IN", name: "English", label: "English" },
    // Add en to avoid some fallback and reload, in I18nContext, as what is compared is language like en instead of en-XX
    // This avoids duplicated /session/create requests and `request cancelled` errors.
    // We should remove the reload in general for long term. https://hopchat.slack.com/archives/C07GU6Y1AMQ/p1756836348747539?thread_ts=1756452663.880389&cid=C07GU6Y1AMQ
    // <Slack-Context: #hts-apac-reviews from @Steve Bai on 2025-08-29> Fix HSBC-IN login create session `request
    //  cancelled` issue: https://github.com/hopper-org/b2bportal/pull/12978
    // </Slack-Context>
    { key: "en", name: "English", label: "English" },
    { key: "en-GB", name: "British English", label: "British English" },
    { key: "en-US", name: "US English", label: "US English" },
  ],
  merchantPayments: "",
  hidePaymentZipCode: true,
  showAIChat: false,
};
